module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22bc31c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-slick/slickCarousel.vue
// module id = 113
// module chunks = 0